import { MessagingAPI } from '../axios'

export type TMessageStatusBody = {
	status: string
}

export type TMessageStatusResponse = {
	success: boolean
	errorMessage: string
	data: {
		status: string
		requestedDependentId?: null | string
	}
}

//Get all messages by user
export const getMessages = async (memberId: string, requestedMemberId: string) => {
	return await MessagingAPI({
		url: `${memberId}/messages/${requestedMemberId}`,
		method: 'GET',
		eCode: 'BP-NFA-0231'
	})
}

//Update message status (read/unread) by user and messageId
export const postMessageStatus = async (
	memberId: string,
	messageId: string,
	body: TMessageStatusBody
): Promise<TMessageStatusResponse> => {
	return await MessagingAPI({
		url: `${memberId}/messages/${messageId}/status`,
		method: 'POST',
		body,
		eCode: 'BP-NFA-0232'
	})
}

//Get message count by memberIds
export const getMessageCountByMemberId = async (
	memberId: string,
	requestedMemberIds: Array<string>
) => {
	// Remove policyholder/primary requested id from the call
	const memberIdIndex = requestedMemberIds.indexOf(memberId)
	requestedMemberIds.splice(memberIdIndex, 1)
	const requestedMemberIdsString = requestedMemberIds.join()

	// setup additional params
	const params = requestedMemberIdsString
		? `?additionalRequestedMemberIds=${requestedMemberIdsString}`
		: ''

	return await MessagingAPI({
		url: `${memberId}/messages/count${params}`,
		method: 'GET',
		eCode: 'BP-NFA-0233'
	})
}

//Delete message by messageId
export const deleteMessageById = async (memberId: string, messageId: string): Promise<string> => {
	return await MessagingAPI({
		url: `${memberId}/messages/${messageId}`,
		method: 'DELETE',
		eCode: 'BP-NFA-0234'
	})
}

export type TTopicsSubscriptions = {
	wellness_selfcare: 'True' | 'False'
	tools_resources: 'True' | 'False'
	deals_discounts: 'True' | 'False'
	benefits: 'True' | 'False'
	maternity: 'True' | 'False'
	behavioral_health: 'True' | 'False'
	diabetes: 'True' | 'False'
	musculoskeletal: 'True' | 'False'
	heart: 'True' | 'False'
	digestive_health: 'True' | 'False'
	oncology: 'True' | 'False'
	update_date?: string
}

type TTopicsData = {
	memberId: string
	isCeleste: boolean
	subscriptions: TTopicsSubscriptions
}

export type TTopicsResponse = {
	success: boolean
	errorMessage: string
	data: TTopicsData
}

export const getTopicPreferences = async (
	memberId: string,
	customError = false
): Promise<TTopicsResponse> => {
	return await MessagingAPI({
		url: `${memberId}/preferences`,
		method: 'GET',
		eCode: 'BP-NFA-0235',
		customError
	})
}

export type TTopicsPostBody = {
	isCeleste: boolean
	subscriptions: TTopicsSubscriptions
}

export const postTopicPreferences = async (
	memberId: string,
	body: TTopicsPostBody,
	customError = false
): Promise<TTopicsData> => {
	return await MessagingAPI({
		url: `${memberId}/preferences`,
		method: 'POST',
		body,
		eCode: 'BP-NFA-0236',
		customError
	})
}
